import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navbar, Nav, Container, Row, NavDropdown } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import SearchBox from './SearchBox'
import { logout } from '../actions/userActions'

function Header() {

    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin

    const dispatch = useDispatch()

    const cart = useSelector(state => state.cart)

    const logoutHandler = () => {
        dispatch(logout())
    }

    return (
        <header>
            <Navbar bg="light" variant="light" expand="lg" collapseOnSelect className="shadow-sm">
                <Container>
                    <LinkContainer to='/'>
                        <Navbar.Brand>trader4all.net</Navbar.Brand>
                    </LinkContainer>
                    <Nav className="me-auto">
                        <LinkContainer to='/'>
                            <Nav.Link><i className="fas fa-home"></i> <span className="ms-1">Home</span></Nav.Link>
                        </LinkContainer>
                    </Nav>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <SearchBox />
                        </Nav>
                        <Nav>

                            <LinkContainer to='/cart'>
                                <Nav.Link >
                                    <i className="fas fa-shopping-cart"></i>Cart
                                    {cart.cartItems.length > 0 && (
                                        <span className="badge bg-primary rounded-pill ms-1">
                                            {cart.cartItems.reduce((acc, item) => acc + item.qty, 0)}
                                        </span>
                                    )}
                                </Nav.Link>
                            </LinkContainer>

                            {userInfo ? (
                                <NavDropdown title={userInfo.name} id='username'>
                                    <LinkContainer to='/profile'>
                                        <NavDropdown.Item>Profile</NavDropdown.Item>
                                    </LinkContainer>

                                    <NavDropdown.Item onClick={logoutHandler}>Logout</NavDropdown.Item>

                                </NavDropdown>
                            ) : (
                                    <LinkContainer to='/login'>
                                        <Nav.Link><i className="fas fa-user"></i> <span className="ms-1">Login</span></Nav.Link>
                                    </LinkContainer>
                                )}


                            {userInfo && userInfo.isAdmin && (
                                <Nav.Link href='/admin/'><i className='fas fa-user'></i> Admin</Nav.Link>
                            )}


                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default Header
